<template>
  <div>
    <input type="checkbox" v-model="ofc" />OFC ({{ roomsMatching('ofc').length }})
    <input type="checkbox" v-model="nlh" />NLH ({{ roomsMatching('nlh').length }})
    <input type="checkbox" v-model="plo" />PLO ({{ roomsMatching('plo').length }})
    <input type="checkbox" v-model="roe" />ROE ({{ roomsMatching('roe').length }})
    <br>
    <input type="checkbox" v-model="empty" />Empty    ({{ roomsMatching('empty').length }})
    <input type="checkbox" v-model="middle" />Middle  ({{ roomsMatching('middle').length }})
    <input type="checkbox" v-model="full" />Full      ({{ roomsMatching('full').length }})
    <br>
    <input type="checkbox" v-model="preparing" />Prep   ({{ roomsMatching('preparing').length }})
    <input type="checkbox" v-model="playing" />Play     ({{ roomsMatching('playing').length }})
    <input type="checkbox" v-model="paused" />Pause     ({{ roomsMatching('paused').length }})
    <input type="checkbox" v-model="waiting" />Wait     ({{ roomsMatching('waiting').length }})
    <input type="checkbox" v-model="ended" />End        ({{ roomsMatching('ended').length }})
    <br>
    <input type="checkbox" v-model="showAll" />Show All ({{ roomsMatching('showAll').length }})
    <li v-for="room, idx in filteredRooms" :key="idx">
      <template v-if="room.name">{{ room.name }} - </template>
      {{ get_room_type(room) }} -
      <template v-if="get_tourney_type(room)">
        {{ get_tourney_type(room) }} -
      </template>
      {{ fmt_blinds(room) }} -
      {{room.playerCount}}/{{ room.playerCountMax }} ({{ room.status }})
      <v-btn small @click="join_room(acc.name, room.gameCode)">join</v-btn>
      <v-btn v-if="isDebug" small  style="border: solid darkred"
             @click="join_room_and_sit(acc.name, room.clubID, room.gameCode, room.settings.bb*100)">
        join&sit100bb
      </v-btn>
      <v-btn v-if="isDebug" small  style="border: solid darkred"
             @click="join_tourney_and_register(acc.name, room.clubID, room.gameCode)">
        join & register
      </v-btn>
    </li>
    <div class="d-flex">
      <v-text-field class="pt-5 mr-2" v-model="friendGameCode" label="Friend game code"
        clearable></v-text-field>
      <v-btn x-large @click="join_room(acc.name, friendGameCode)"
             :disabled="friendGameCode.length <= 3">
        join
      </v-btn>
    </div>
    <div class="d-flex">

      <v-btn x-large @click="join_challenge(acc.name)">
        join challenge
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {roomType} from "@/plugins/helpers";

export default {
  props: ["acc", "rooms"],
  data() {
    return {
      ofc: true,
      nlh: true,
      plo: true,
      roe: true,

      empty: true,
      middle: true,
      full: false,

      preparing: true,
      playing: true,
      paused: true,
      waiting: true,
      ended: false,

      showAll: false,

      friendGameCode: '',
    };
  },
  computed: {
    filteredRooms() {
      let rooms = [];
      for (let r of this.rooms) {
        // game type
        var okGame =
            this.ofc && this.roomMatchesFilter(r, 'ofc') ||
            this.nlh && this.roomMatchesFilter(r, 'nlh') ||
            this.plo && this.roomMatchesFilter(r, 'plo') ||
            this.roe && this.roomMatchesFilter(r, 'roe');

        // num players
        var okPlayers =
            this.empty && this.roomMatchesFilter(r, 'empty') ||
            this.middle && this.roomMatchesFilter(r, 'middle') ||
            this.full && this.roomMatchesFilter(r, 'full');

        // status
        var okStatus =
            this.preparing && this.roomMatchesFilter(r, 'preparing') ||
            this.playing && this.roomMatchesFilter(r, 'playing') ||
            this.paused && this.roomMatchesFilter(r, 'paused') ||
            this.waiting && this.roomMatchesFilter(r, 'waiting') ||
            this.ended && this.roomMatchesFilter(r, 'ended');

        if (okGame && okPlayers && okStatus || this.showAll) {
          rooms.push(r);
        }
      }
      return rooms;
    },
    ...mapGetters([
      'isDebug',
      'isClaud',
    ]),
  },
  methods: {
    roomsMatching(filter) {
      let rooms = [];
      for (let r of this.rooms) {
        if (this.roomMatchesFilter(r, filter)) {
          rooms.push(r);
        }
      }
      return rooms;
    },
    roomMatchesFilter(room, filter) {
      if (filter === 'showAll') {
        return true;
      }

      let t = this.get_room_type(room);
      if (filter === 'ofc') {
        return t === 'OFC';
      } else if (filter === 'nlh') {
        return t === "Hold'em";
      } else if (filter === 'plo') {
        return t.indexOf("PLO") >= 0;
      } else if (filter === 'roe') {
        return t.indexOf("ROE") >= 0;
      } else if (filter === 'preparing') {
        return room.status === 'PREPARE';
      } else if (filter === 'playing') {
        return room.status === 'PLAYING' || room.status === 'HANDEND';
      } else if (filter === 'paused') {
        return room.status === 'PAUSE' || room.status === 'PAUSED';
      } else if (filter === 'waiting') {
        return room.status === 'WAITING';
      } else if (filter === 'ended') {
        return room.status === 'END';
      } else if (filter === 'empty') {
        return room.playerCount === 0;
      } else if (filter === 'full') {
        return room.playerCount === room.playerCountMax;
      } else if (filter === 'middle') {
        return room.playerCount > 0 && room.playerCount < room.playerCountMax;
      } else {
        console.error("Bad filter:", filter);
        return true;
      }
    },
    get_room_type(room) {
      return roomType(room.settings);
    },
    get_tourney_type(room) {
      if (room.mainRoomDataObject) {
        return 'MTT';
      }

      let rs = room.settings;

      if (rs.rummy) {
        return '';
      } 

      if ('prizePlan' in rs) {
        if (rs.maxPlayer <= 9) { return 'SNG'; }
        return 'MTT';
      }
      return '';
    },
    fmt_blinds(room) {
      let rs = room.settings;
      if ('prizePlan' in rs) {
        return '$' + rs.buyInTicket + '+' + rs.buyInTips;
      }
      return '$' + this.get_blinds(room);
    },
    get_blinds(room) {
      let rs = room.settings;
      var divider = 1.0;
      if (rs.withDecimal) {
        divider = 100.0;
      }
      return rs.bb / divider;
    },
    join_challenge(name) {
      this.$socket.emit("join_challenge", {'displayID': name});
    },
    join_room(name, game_code) {
      this.$socket.emit("join_room", {'displayID': name, 'gameCode': game_code});
    },
    join_room_and_sit(name, club_id, game_code, amount_hu) {
      console.log("We are here!!!!! -----", club_id,);
      this.$socket.emit("join_room_and_sit", {
        'displayID': name,
        'clubID': club_id,
        'gameCode': game_code,
        'buyinChips': amount_hu,
      });
    },
    join_tourney_and_register(name, club_id, game_code) {
      console.log("We are here!!!!! -----", club_id,);
      this.$socket.emit("join_tourney_and_register", {
        'displayID': name,
        'clubID': club_id,
        'gameCode': game_code,
      });
    },
  }
}
</script>
